import { useI18N, useLegalCheckbox } from "@sundae/react-hooks";
import { Notice } from "@sundae/ui-toolkit";
import { ADA_METADATA } from "@sundaeswap/core";
import { FC, useMemo } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { EOrderFlowState, OrderActions, useOrderContext } from "../../../stores/OrderContext";
import { IAssetMetaData } from "../../../types/Asset.types";
import { getAssetName } from "../../../utils/assets.utils";

const TasteTestContributionWarning: FC<{ withConsent?: boolean }> = ({ withConsent = false }) => {
  const { t } = useI18N("taste-test");
  const {
    state: {
      flowData: { flowState, orderConsent },
    },
    dispatch,
  } = useOrderContext();
  const {
    state: { tasteTest },
  } = useTasteTestContext();
  const suppliedAsset = tasteTest?.asset ?? ({} as IAssetMetaData);
  const { showErrorFlash } = useLegalCheckbox();

  // TODO: taste-test; add check for  withdrawal / last call withdrawal and return labels based on i18n keys
  const warningLabel = useMemo(() => {
    if ([EOrderFlowState.preview, EOrderFlowState.submittingCancelled].includes(flowState)) {
      return t("detail.widget.warning.confirmation", {
        pool: `${getAssetName(ADA_METADATA)}-${getAssetName(suppliedAsset)}`,
      });
    }

    return t("detail.widget.warning.contribution", {
      pool: `${getAssetName(ADA_METADATA)}-${getAssetName(tasteTest!.asset)}`,
    });
  }, [tasteTest?.asset, flowState, suppliedAsset, t]);

  const withConsentProps = useMemo(() => {
    if (!withConsent) {
      return {};
    }

    return {
      showErrorFlash,
      onConsentChange: () => {
        OrderActions.setOrderConsent({ checked: !orderConsent.checked }, dispatch);
      },
      isConsentChecked: orderConsent.checked,
      withConsent,
    };
  }, [withConsent, orderConsent.checked, showErrorFlash, dispatch]);

  return (
    <Notice type="warning" size="xs" title={t("detail.widget.warning.title")} {...withConsentProps}>
      {warningLabel}
    </Notice>
  );
};

export default TasteTestContributionWarning;
